import { IPaymentService } from "../interfaces/services/IPaymentService";
import { TransactionType } from "../agreggates/payment/transactionType";
import { Payment, PixPaymentRequest, PixPaymentResponse } from "../agreggates/payment/payment";
import { HttpRepository } from "Infrastructure/repositories/api/_HttpRepository";
import { IHttpRepository } from "Infrastructure/interfaces/IHttpRepository";
import { IPinpadService } from "modules/payment/application/interfaces/IPinpadService";
import { Kiosk } from "domains/kiosk/aggregates/Kiosk";
import enviroment from "corss-cutting/enviroment";
import { resolvePinpadService } from "./resolvePinpadService";

// NOTA (débito técnico conhecido): hoje nenhum fluxo real de pinpad chama payAsync/cancelPaymentAsync
// através deste PaymentService — o único uso de PaymentService() no projeto é em Pix.tsx, que só
// chama pixPayment/pixPaymentStatus. A integração real e efetiva de pagamento via pinpad (incluindo
// resolvePinpadService(kiosk) para ativação por kiosk.tipoAdquirente) está em UsePinpad.tsx. Não
// presuma que editar payAsync/cancelPaymentAsync aqui é suficiente para mudar o comportamento do
// totem — verifique UsePinpad.tsx primeiro.
export const PaymentService = (
): IPaymentService => {
  const httpRepository: IHttpRepository = HttpRepository();
  const payAsync = async (orderValue: number, transactionType: TransactionType, kiosk?: Kiosk): Promise<Payment> => {
    try {
      const paymentRepository: IPinpadService = resolvePinpadService(kiosk);
      const pay = await paymentRepository.payAsync(orderValue, transactionType, kiosk);
      if (!pay.success) {
        throw new Error(pay.errorMessage ?? "");
      }
      return pay
    } catch (error) {
      throw error;
    }
  };
  const cancelPaymentAsync = async (value: number, typePayment: TransactionType, couponNumber: string, paymentDate: string) => {
    // LIMITAÇÃO CONHECIDA: resolvePinpadService() é chamado aqui sem `kiosk`, então o estorno só
    // respeita a flag local (isAdyenForcedEnabled), nunca kiosk.tipoAdquirente === Adyen — ao
    // contrário de payAsync acima e de UsePinpad.tsx, que já passam `kiosk`. Isso não é uma
    // regressão ativa (cancelPaymentAsync não tem caller de UI real hoje), mas precisa ser corrigido
    // antes de qualquer tela de estorno ser implementada. A correção correta é mudar a assinatura
    // pública de IPaymentService.cancelPaymentAsync para receber `kiosk`, o que está fora do escopo
    // desta feature (Global Constraints do plano proíbem mudar assinatura de IPaymentService/IPinpadService).
    const paymentRepository: IPinpadService = resolvePinpadService();
    const cashback = await paymentRepository.cancelPaymentAsync(value, typePayment, couponNumber, paymentDate)
    console.log("cashback", cashback);
    return cashback
  }

  const pixPayment = async (payRequest: PixPaymentRequest): Promise<PixPaymentResponse> => {
    // const result = await httpRepository.postAsync<PixPaymentRequest, PixPaymentResponse>('https://b3c4-200-166-48-200.ngrok-free.app/Promptus.Meep.Server/api/Pix/', payRequest);
    const result = await httpRepository.postAsync<PixPaymentRequest, PixPaymentResponse>(`${enviroment.pixApiUrl}/Pix/`, payRequest);
    return result;
    // return Promise.resolve(pixPendingResponseMock)
  }

  const pixPaymentStatus = async (paymentId: string): Promise<PixPaymentResponse> => {
    // const result = await httpRepository.getAsync<PixPaymentResponse>(`https://b3c4-200-166-48-200.ngrok-free.app/Promptus.Meep.Server/api/Pix/${paymentId}`);
    const result = await httpRepository.getAsync<PixPaymentResponse>(`${enviroment.pixApiUrl}/Pix/${paymentId}`);
    return result;
    // return Promise.resolve(pixApprovedResponseMock)
  }  
  return { payAsync, cancelPaymentAsync, pixPayment, pixPaymentStatus };
};
